import { LoadingButton } from '@mui/lab';
import { postUnbarringAction } from '_models/redux/request-unbarring-action/action';
import ModalCustomActions from 'modules/support/my-tickets/flow/detailTickets/components/actions-tickets/ModalCustomActions';
import { connect } from 'react-redux';

import { ActionUnbarringHook } from '../../hooks/actionsTicketsHooks/actionUnbarringHook';

export const ActionUnbarring = (props) => {
  const {
    modalOpen,
    setModalOpen,
    isLoading,
    setIsLoading,
    alert,
    setAlert,
    errorMssge,
    setErrorMssge,
    severityAlert,
    setSeverityAlert,
    handleClickUnbarring,
    handleSubmit,
    clearFunction,
  } = ActionUnbarringHook(props);
  return (
    <div>
      <LoadingButton
        fullWidth
        size='small'
        onClick={handleClickUnbarring}
        variant='outlined'
        className='button'
      >
        <h4>Reanudar tráfico saliente (Unbarring)</h4>
      </LoadingButton>
      {modalOpen && (
        <ModalCustomActions
          modalOpen={modalOpen}
          setOpenModal={setModalOpen}
          titleModal='Actualizar Barring'
          subTitleModal='¿Desea actualizar Barring?'
          actionRequest={handleSubmit}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          alert={alert}
          setAlert={setAlert}
          errorMssge={errorMssge}
          setErrorMssge={setErrorMssge}
          severityAlert={severityAlert}
          setSeverityAlert={setSeverityAlert}
          clearFunction={clearFunction}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  actionPostUnbarringAction: state.actionPostUnbarringAction,
});
const mapDispatchToProps = {
  postUnbarringAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ActionUnbarring);
